import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type IDivisionNode = {
  id: number;
  name: string;
  groupId: number;
  employerId: number;
  clientId: number;
};

type divisionState = {
  list: IDivisionNode[] | [];
};

const initialState: divisionState = { list: [] };

const slice = createSlice({
  name: "divisions",
  initialState,
  reducers: {
    setDivisionsList(state, action: PayloadAction<divisionState>) {
      state.list = action.payload.list ?? [];
    },
    clearDivisions(state) {
      state.list = [];
    },
  },
});

export const { setDivisionsList, clearDivisions } = slice.actions;
export default slice.reducer;
